import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import { useStateContext } from '../../hooks/context/Context';
import Logo from '../../images/logo/1_logo.png';
import LogoutImg from '../../images/SideBar/Logout';
import { handleLogout } from '../../util/constant';
import { INavLinkItem, links } from './MockSidebar';

/**
 * Sidebar component
 */
export const Sidebar: React.FC = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const location = useLocation();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize && screenSize <= 1101) {
      setActiveMenu(false);
    }
  };

  const handleDropdownToggle = (menu: string) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const isSubMenuActive = (subLinks: INavLinkItem[]) => {
    return subLinks.some((subLink) => location.pathname.includes(subLink.link));
  };

  const activeLink =
    "flex items-center gap-5 pl-4 pt-2 pb-1.5 font-bold rounded-xl text-headColor bg-mainBg m-1";
  const normalLink =
    "flex items-center gap-5 pl-4 pt-2 pb-1.5 text-md text-fontColor dark:text-gray-200 dark:hover:text-black m-1";

  return (
    <div
      className={`absolute top-0 left-0 z-10 h-screen pb-10  ${
        screenSize && screenSize <= 1101 ? "w-full" : "w-64"
      }`}
    >
      {activeMenu ? (
        <>
          <div className="flex justify-between items-center border-b border-border2">
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-9 mb-6 flex text-[22px] font-extrabold text-headColor w-40 h-7 mt-6"
            >
              <span><img src={Logo} alt="Logo" /></span>
            </Link>
          </div>
          <div className='relative h-[90vh]'> 
            {links.map((item) => (
              <div key={item.title} className='h-full' >
                <p className="text-gray-400 dark:text-gray-400 m-2 mt-2 uppercase">
                  {item.title}
                </p>
                <div className="overflow-y-auto h-[80vh]"> 
                {item.links.map((link) => (
                  <div key={link.name} className="flex flex-col">
                    <NavLink
                      to={link.sub ? "#" : `/${link.link}`}
                      key={link.name}
                      onClick={(e) => {
                        if (link.sub) {
                          e.preventDefault(); 
                          handleDropdownToggle(link.name);
                        } else {
                          handleCloseSideBar();
                        }
                      }}
                      className={({ isActive }) =>
                        isActive || isSubMenuActive(link.sub || [])
                          ? activeLink
                          : normalLink
                      }
                      style={({ isActive }) => ({
                        borderLeftColor:
                          isActive || isSubMenuActive(link.sub || [])
                            ? currentColor
                            : "transparent",
                      })}
                    >
                      {link.icon}
                      <span className="capitalize">{link.name}</span>
                      {link.sub && (
                        <span className="ml-auto">
                          {openDropdown === link.name ? "▲" : "▼"}
                        </span>
                      )}
                    </NavLink>
                    {link.sub && openDropdown === link.name && (
                      <div className="pl-6">
                        {link.sub.map((subLink: INavLinkItem) => (
                          <NavLink
                            to={`/${subLink.link}`}
                            key={subLink.name}
                            onClick={handleCloseSideBar}
                            className={({ isActive }) =>
                              isActive ? activeLink : normalLink
                            }
                            style={({ isActive }) => ({
                              borderLeftColor: isActive
                                ? currentColor
                                : "transparent",
                            })}
                          >
                            {subLink.icon}
                            <span className="capitalize">{subLink.name}</span>
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                </div>
              </div>
            ))}
            <div className="absolute bottom-1 w-full cursor-pointer">
              <div
                className={`flex items-center gap-5 pl-4 pt-2 pb-1.5 rounded-xl m-1 text-white bg-logoutBg ${activeMenu? "w-64" : "w-44"}`}
                onClick={handleLogout}
              >
                <LogoutImg />
                <span className="capitalize">Log Out</span>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="mt-6 overflow-y-auto">
            {links.map((item) => (
              <div key={item.title}>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.link}`}
                    key={link.name}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                    style={({ isActive }) => ({
                      borderLeftColor: isActive ? currentColor : "transparent",
                      
                    })}
                  >
                    {link.icon}
                  </NavLink>
                ))}
              </div>
            ))}
            <div className="absolute bottom-1 w-full">
              <div
                className="flex items-center cursor-pointer gap-5 pl-4 pt-2 pb-1.5 rounded-xl m-1 text-white bg-logoutBg"
                onClick={handleLogout}
              >
                <LogoutImg />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
